import { useEffect } from 'react';

const useMount = onMount => useEffect(onMount, []); // eslint-disable-line react-hooks/exhaustive-deps

export default useMount;
